"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ArrowLeftDownAngle16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.58579 13.7929C5.58579 14.2383 5.04722 14.4614 4.73223 14.1464L1.29289 10.7071C0.902369 10.3166 0.902368 9.68341 1.29289 9.29288L4.73223 5.85354C5.04722 5.53856 5.58579 5.76164 5.58579 6.20709L5.58579 8.99999L10.5858 8.99999C11.6904 8.99999 12.5858 8.10456 12.5858 6.99999L12.5858 3.99999C12.5858 3.4477 13.0335 2.99999 13.5858 2.99999C14.1381 2.99999 14.5858 3.4477 14.5858 3.99999L14.5858 6.99999C14.5858 9.20913 12.7949 11 10.5858 11L5.58579 11L5.58579 13.7929Z", fill: "#383F49" }));
}
function ArrowLeftDownAngle16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ArrowLeftDownAngle16Svg, Object.assign({}, svgProps)));
}
exports.default = ArrowLeftDownAngle16;
//# sourceMappingURL=ArrowLeftDownAngle16.js.map